module.exports = __webpack_public_path__ + "static/03-2dfc737c84ebb0dadb1292328225d316.jpg";